package com.neurobs.ccab

case class ChatClientId
(
	uniqueId: String,
	`type`: String,
	user: String
)

object ChatClientId {
	val testStationType = "t"
	val examinerType = "e"
}

object ChatRoom {

}
